/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {Link} from 'react-router-dom'
import {useLocation} from 'react-router'
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../reusable'
import { Tr } from '../../../_metronic/i18n/Tr'
import { useLang } from '../../../_metronic/i18n/Metronici18n'

const RentableSpaceDetailsHeader: React.FC = () => {
  const t = Tr()
  const lang = useLang()
  const location = useLocation();
  const rentablespaceId = (location.state as any)?.rentablespaceId || '';
  const [rentableSpaceDetails, setRentableSpaceDetails] = useState([]);

  // rentable space Details api call
  const rentableSpaceDetailsApiCall=async()=>{
        
    var param:any={
        rentablespaceId:String(rentablespaceId),
    }
    var response:any=await fetchData("public/rentablespaceDetail",param)
    
    if(response.status=="200")
    { 
      setRentableSpaceDetails(response.data);
    }
    else
    {
        toasterrormsg(response.message)
    }
  }
  useEffect(()=>{
    rentableSpaceDetailsApiCall()
  },[])
  return (
    <>
    {
      rentableSpaceDetails.map((rentableSpace:any,index:any)=>{
        
        var imageUrl = '';
        var totalImage = '';
        if(rentableSpace['images'].length != 0){
          imageUrl = rentableSpace['images'][0].mediaPath;
          totalImage = '+'+(rentableSpace['images'].length-1);
        }else{
          imageUrl = toAbsoluteUrl("/media/avatars/300-1.jpg");
          totalImage = '';
        }
        return (

          <div className='card mb-5 mb-xl-10' key={index}>
            <div className='card-body pt-9 pb-0'>
              <div className='d-flex flex-wrap flex-sm-nowrap mb-3'>
                <div className='me-7 mb-4'>
                  <div className='symbol symbol-100px symbol-lg-160px symbol-fixed position-relative'>
                    <img src={imageUrl} alt='vendor avatar' />
                    {
                      totalImage ? (
                        <div className='position-absolute translate-middle top-0 start-100 mb-6 bg-success rounded-circle border border-4 border-white h-40px w-40px text-white fw-bold fs-4 p-1'>{totalImage}</div>
                      ):('')
                    }
                  </div>
                </div>

                <div className='flex-grow-1'>
                  <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                    <div className='d-flex flex-column'>
                      <div className='d-flex align-items-center mb-2'>
                        <div className='text-gray-800 fs-2 fw-bolder me-1'>
                          {getTranslatedValue(lang, rentableSpace, '_name')}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className='d-flex flex-wrap flex-stack'>
                    <div className='d-flex flex-column flex-grow-1 pe-8'>
                      <div className='d-flex flex-wrap'>
                        <div className='border border-gray-300 border-dashed rounded min-w-125px py-3 px-4 me-6 mb-3'>
                          <div className='d-flex align-items-center'>
                            <div className='fs-2 fw-bolder'>{rentableSpace['availablespace']}</div>
                          </div>
                          <div className='fw-bold fs-6 text-gray-400'>{t('Available Space')}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className='d-flex overflow-auto h-55px'>
                <ul className='nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bolder flex-nowrap'>
                  <li className='nav-item'>
                    <Link
                      className={
                        `nav-link text-active-primary me-6 ` +
                        (location.pathname === '/rentablespaceoverview/' && 'active')
                      }
                      to='../rentablespaceoverview/'
                      state={{rentablespaceId:rentablespaceId}}
                    >
                      {t('All Details')}
                    </Link>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        )
      })
    }
    </>
  )
}

export {RentableSpaceDetailsHeader}
